<template>
  <div
    v-if="listing"
    class="message-listing fill-main"
  >
    <div>
      <div class="row">
        <button
          class="back-button btn btn-transparent"
          @click="goBack()"
        >
          <arrow-left-icon />
        </button>
        <h2>
          [{{ listing.type }}]
          {{ listing.title }}
          <template v-if="listing.price">
            ~ ${{ listing.price }}
          </template>
        </h2>
      </div>
      <div
        v-if="listing.images.length > 0"
        class="images"
      >
        <router-link
          v-for="image in listing.images"
          :key="image.id"
          :to="{ name: 'post_detail', params: { id: listing.id } }"
          class="frame"
        >
          <img :src="image.url">
        </router-link>
      </div>
      <!-- <p>TODO: find out what to put here</p> -->
      <!-- {{ listing }} -->
    </div>
    <div v-if="owner">
      <router-link
        replace
        :to="{name: 'message_listing', params: { id: listing.id } }"
      >
        &lt;- View other inquiries
      </router-link>
    </div>
    <chat-room
      v-if="room"
      :room="room"
      :show-sidebar="false"
    >
      <template v-slot:empty>
        <i>Empty</i>
      </template>
    </chat-room>
    <div v-else-if="owner">
      <div v-if="rooms.length === 0">
        <em>No one is chatting with you about this yet</em>
      </div>
      <div v-else>
        <h3>Post inquiries</h3>
      </div>
      <router-link
        v-for="chatroom of rooms"
        :key="chatroom.name"
        replace
        :to="{name: 'message_listing', params: { id: listing.id, user: chatroom.user.id } }"
        class="room"
      >
        <avatar :user="chatroom.user" />
        <span>
          {{ chatroom.user.first_name }}
          {{ chatroom.user.last_name }}
        </span>
        <span>
          {{ new Date(chatroom.created_on).toLocaleString() }}
        </span>
      </router-link>
    </div>
    <div v-else>
      You aren't logged in
    </div>
  </div>
  <div v-else-if="status === 'loading'">
    Loading listing...
  </div>
  <div v-else>
    Sorry, this listing doesn't exist
  </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';
import ChatRoom from '../../components/GGChatRoom.vue';

export default {
  name: 'MessageProfile',
  components: {
    Avatar,
    ChatRoom,
  },
  data() {
    return {
      status: 'loading',
      listing: null,
      rooms: [],
    };
  },
  computed: {
    id() { return parseInt(this.$route.params.id, 10); },
    room() {
      if (this.listing) {
        if (this.owner) {
          if (this.other) {
            return `_m2l.${this.id}.${this.other}`;
          }
        } else if (this.userData) {
          return `_m2l.${this.id}.${this.userData.id}`;
        }
      }
      return null;
    },
    other() {
      return this.$route.params.user;
    },
    owner() {
      return (
        this.listing
        && this.userData
        && this.listing.user.id === this.userData.id
      );
    },
  },
  async mounted() {
    const response = await this.api({ url: `posts/${this.id}/` });
    if (response.ok) {
      this.listing = response.body;

      if (!this.owner && this.$route.params.user) {
        this.$router.replace({ name: 'message_listing', params: { id: this.listing.id } });
      } else {
        const response2 = await this.api({ url: 'chatrooms/' });
        const rooms = response2.body.filter(
          room => room.name.startsWith(`_m2l.${this.listing.id}`),
        );
        this.rooms = await Promise.all(rooms.map(async (room) => {
          const other = room.name.split('.')[2];
          return {
            name: room.name,
            user: (await this.api({ url: `users/${other}/` })).body,
            created_on: room.created_on,
          };
        }));
      }
    }
    this.status = null;
  },
};
</script>

<style lang="scss" scoped>
.images .frame {
  display: inline-block;
  width: 75px;
  height: 75px;
  background-position: center;
  img {
    object-fit: cover;
  }
}
.row h2 {
  margin-left: 8px;
}
.frame {
  max-width: 150px;
  max-height: 150px;
}
.frame img {
  width: 100%;
  height: 100%;
}
.room {
  color: inherit;
  background-color: #fff;
  border: 1px solid var(--gray);
  border-top: none;
  font-size: 80%;
  transition: background-color 0.2s ease-in-out;
  padding: 0.5rem;
  display: flex;

  &:focus,
  &:hover {
    background-color: var(--gray-lightest);
  }
  &:first-child {
    border-top: 1px solid var(--gray);
  }

  span {
    padding: 0 5px;
    flex: 1 1 50%;
  }
}
</style>
